import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import FormField from "components/molecules/FormField/FormField";
import PickupDeliveryDate from "pages/shipper/RequestForm/components/Schedule/PickupDeliveryDate";
import PortInfo from "./PortInfo";

function VesselScheduleForm({ countries }: any) {
  const intl = useIntl();
  const [holidays, setHolidays] = useState({});

  return (
    <>
      <hr className="mt-xl mb-xl " />
      <div className="mt-4">
        <Row className="mb-1">
          <Col xs={12}>
            <div className="flex-row flex-wrap">
              <div className="w-200 pr-16">
                <h6>
                  <FormattedMessage
                    id="tracking.components.editScheduleDialog.vesselSchedule"
                    defaultMessage="Vessel schedule"
                  />
                </h6>
              </div>
              <div style={{ width: "504px" }}>
                <div className="w-300">
                  <FormField
                    validations={{
                      shouldUnregister: true,
                    }}
                    id="id_pickup_contact_email"
                    label={intl.formatMessage({
                      id: "quote.provider.vesselNumber",
                      defaultMessage: "Vessel number / IMO",
                    })}
                    type="textinput"
                    field_id="schedule.vessel_number"
                  />
                </div>
                <div className="d-flex mt-4">
                  <div>
                    <label>
                      <FormattedMessage id="quote.provider.vesselDepartureDate" defaultMessage="Vessel departure Date" />
                    </label>
                    <PickupDeliveryDate
                      datePickerProps={{
                        name: "schedule.vessel_departure_date",
                        required: true,
                        shouldUnregister: true,
                      }}
                      countries={countries}
                      holidays={holidays}
                      setHolidays={setHolidays}
                    />
                  </div>
                </div>
                <div>
                  <PortInfo prefix="departure" countries={countries} />
                </div>
                <div className="d-flex mt-4">
                  <div className="w-192 align-date">
                    <label>
                      <FormattedMessage id="quote.provider.vesselArrivalDate" defaultMessage="Vessel arrival date" />
                    </label>
                    <PickupDeliveryDate
                      datePickerProps={{
                        name: "schedule.vessel_arrival_date",
                        required: true,
                        shouldUnregister: true,
                      }}
                      countries={countries}
                      holidays={holidays}
                      setHolidays={setHolidays}
                    />
                  </div>
                </div>
                <div>
                  <PortInfo prefix="arrival" countries={countries} />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default VesselScheduleForm;
